import { DeletableEntity } from "graphqlBase/__utils__/genericDelete";
import { atom } from "recoil";

export const genericDeleteParams = atom<{
  id: string | string[] | undefined;
  entity: DeletableEntity | undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  afterDelete?: (data: any) => void;
  modalTitle: string | undefined;
  modalMessage?: string | undefined;
  submitButtonText?: string | undefined;
  customModalContent?: React.ReactNode | undefined;
  detailsShowLabel?: string | undefined;
  detailsHideLabel?: string | undefined;
}>({
  key: "genericDeleteParams",
  default: {
    id: undefined,
    entity: undefined,
    afterDelete: undefined,
    modalTitle: undefined,
    submitButtonText: undefined,
    modalMessage: undefined,
    customModalContent: undefined,
    detailsShowLabel: undefined,
    detailsHideLabel: undefined,
  },
});
